import { notification } from "antd";
import { setIsUserLoggedIn, setToken, setUserAccessData, setUserDetails } from "./sessionHelper";
import moment from "moment";

export const getLandingPage= (roles:any, employeeOrderAccess:any)=> {
    if(employeeOrderAccess && employeeOrderAccess!==undefined){
        if (roles.includes('admin')) {
            return 'UserDashboard' ;
        }
    }
    else{
        return 'RequestAccess' ;
    }
   
}

export const getUserRole = (data: object | null) => {
    if (data && typeof data === "object") {
      // Find the first property (role) in the object
      const role = Object.keys(data)[0];
      return role || null;
    }
    return null;
  }

export const checkAccess=(userRole:string, moduleName: string, roleAccessMap: { [key: string]: any }[], accessType: string): boolean => {

    const roleAccess = roleAccessMap.find((role) => role.module === moduleName);
    if (roleAccess) {
      return roleAccess[accessType];
    }
    return false;
  }  

export const handleLogout = () => {
    // Clear local storage and redirect to login page
    setTimeout(() => {
        setIsUserLoggedIn(false);
        setToken('');
        setUserDetails(null);
        setUserAccessData(null);
        
        if (window.location.pathname !== '/login') {
            window.location.pathname = '/login';
        }
    } , 2000);
    
  };

  interface Params {
    page?: number;
    size?: number;
    opportunityId?: string;
    sort?: string[];
  }
  
  export const composeParamsString = (params: Params): string => {
    const paramStrings: string[] = [];
  
    if (params.page|| params.page === 0) {
      paramStrings.push(`page=${params.page}`);
    }
  
    if (params.size) {
      paramStrings.push(`size=${params.size}`);
    }
    if (params.opportunityId) {
      paramStrings.push(`opportunityId=${params.opportunityId}`);
    }
    
    if (params.sort) {
      params.sort.forEach((sortParam) => {
        paramStrings.push(`sort=${sortParam}`);
      });
    }
  
    return paramStrings.join('&');
  };

  export const concatenateRoleNames=(roles: { id: number; role: string }[]): string=> {
      
    if(roles===undefined || roles===null || roles.length===0){
      return'';
    }
    const roleNames = roles.map((role) => role.role);
    return roleNames.join(', ');
  }

  export const rejectedApiMessage = (error: string) => {
    if (error.includes('401')) {
      notification.warning({
        message: 'Session Expired',
        description: 'Please login again',
      });
      handleLogout();
    } else {
      if(error.includes('ERROR_FROM_MYSHEETS')){
        notification.error({
          message: 'Error in mySheets',
          description: error.split("_MYSHEETS")[1],
        });
      }
      else{
        notification.error({
          message: 'Error',
          description: error, 
        });
      }

    }
  };
  export const pendingRequest_column=[
        {
            title: 'Request Id',
            dataIndex: 'id',
            key: 'id',
            width:150
        },
        {
          title: 'Request Type',
          dataIndex: 'type',
          key: 'type',
          width:150
        },
        {
          title: 'Employee Name',
          dataIndex: 'employeeName',
          key: 'employeeName',
          width:150
        },
        {
          title: 'Employee Email',
          dataIndex: 'employeeEmail',
          key: 'employeeEmail',
          width:150
        },
        {
          title: 'Employee Id',
          dataIndex: 'employeeId',
          key: 'employeeId',
          width:150
        },
        {
          title: 'Business Unit',
          dataIndex: 'businessUnit',
          key: 'businessUnit',
          width:150
        },
        {
          title: 'Department',
          dataIndex: 'department',
          key: 'department',
          width:150
        },
        {
          title: 'Reporting Manager Name',
          dataIndex: 'reportingManagerName',
          key: 'reportingManagerName',
          width:150
        },
        {
          title: 'Reporting Manager Email',
          dataIndex: 'reportingManagerEmail',
          key: 'reportingManagerEmail',
          width:150
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          width:150
        },
        {
          title: 'Access Reason',
          dataIndex: 'accessReason',
          key: 'accessReason',
          width:150
        },
        {
          title: 'Request Status',
          dataIndex: 'requestStatus',
          key: 'requestStatus',
          width:150
        }
  ];

export const pendingRequest_data= [
    {
        "id": 3,
        "type": "NEW",
        "employeeName": "Shubham Raturi",
        "employeeEmail": "shubham.raturi1@indegene.com",
        "employeeId": "IND15425",
        "businessUnit": "Global Operations",
        "department": "Enterprise Technology",
        "reportingManagerName": "Anand Rao B S",
        "reportingManagerEmail": "ananda.rao@indegene.com",
        "role": "Admin",
        "accessReason": "samplee",
        "reminderEmailCount": 0,
        "requestStatus": "PENDING",
        "approvalRejects": []
    },
    {
        "id": 3,
        "type": "NEW",
        "employeeName": "Shubham Raturi",
        "employeeEmail": "shubham.raturi1@indegene.com",
        "employeeId": "IND15425",
        "businessUnit": "Global Operations",
        "department": "Enterprise Technology",
        "reportingManagerName": "Anand Rao B S",
        "reportingManagerEmail": "ananda.rao@indegene.com",
        "role": "Admin",
        "accessReason": "samplee",
        "reminderEmailCount": 0,
        "requestStatus": "PENDING",
        "approvalRejects": []
    },
    {
        "id": 3,
        "type": "NEW",
        "employeeName": "Shubham Raturi",
        "employeeEmail": "shubham.raturi1@indegene.com",
        "employeeId": "IND15425",
        "businessUnit": "Global Operations",
        "department": "Enterprise Technology",
        "reportingManagerName": "Anand Rao B S",
        "reportingManagerEmail": "ananda.rao@indegene.com",
        "role": "Admin",
        "accessReason": "samplee",
        "reminderEmailCount": 0,
        "requestStatus": "PENDING",
        "approvalRejects": []
    },
    {
        "id": 3,
        "type": "NEW",
        "employeeName": "Shubham Raturi",
        "employeeEmail": "shubham.raturi1@indegene.com",
        "employeeId": "IND15425",
        "businessUnit": "Global Operations",
        "department": "Enterprise Technology",
        "reportingManagerName": "Anand Rao B S",
        "reportingManagerEmail": "ananda.rao@indegene.com",
        "role": "Admin",
        "accessReason": "samplee",
        "reminderEmailCount": 0,
        "requestStatus": "PENDING",
        "approvalRejects": []
    },
    {
        "id": 3,
        "type": "NEW",
        "employeeName": "Shubham Raturi",
        "employeeEmail": "shubham.raturi1@indegene.com",
        "employeeId": "IND15425",
        "businessUnit": "Global Operations",
        "department": "Enterprise Technology",
        "reportingManagerName": "Anand Rao B S",
        "reportingManagerEmail": "ananda.rao@indegene.com",
        "role": "Admin",
        "accessReason": "samplee",
        "reminderEmailCount": 0,
        "requestStatus": "PENDING",
        "approvalRejects": []
    }
]  

export const activeUser_column:any=[
    {
      title: 'Employee Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Employee Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Employee Id',
      dataIndex: 'employeeId',
      key: 'employeeId',
    },
    {
      title: 'Business Unit',
      dataIndex: 'businessUnit',
      key: 'businessUnit',
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: 'Reporting Manager Name',
      dataIndex: 'reportingManagerName',
      key: 'reportingManagerName',
    },
    {
      title: 'Reporting Manager Email',
      dataIndex: 'reportingManagerEmail',
      key: 'reportingManagerEmail',
    },
    {
      title: 'Access Given On',
      dataIndex: 'createdDate',
      key: 'createdDate',
    }
];
export const activeUser_data:any=[
    {
        "createdBy": "shubham.raturi1@indegene.com",
        "createdDate": "2023-11-07T04:52:24.804+00:00",
        "lastModifiedBy": "shubham.raturi1@indegene.com",
        "lastModifiedDate": "2023-11-07T04:52:24.804+00:00",
        "id": "2",
        "email": "saikiran.varala@indegene.com",
        "name": "saikiran.varala",
        "businessUnit": "Global Operations",
        "department": "Corporate Global Operations",
        "reportingManagerName": "saikiran v",
        "reportingManagerEmail": "saikiran.varala@indegene.com",
        "employeeStatus": "ACTIVE",
        "accessStatus": "ACCESSIBLE"
    },
    {
        "createdBy": "shubham.raturi1@indegene.com",
        "createdDate": "2023-11-15T09:48:05.145+00:00",
        "lastModifiedBy": "shubham.raturi1@indegene.com",
        "lastModifiedDate": "2023-11-15T09:48:05.145+00:00",
        "id": "5",
        "email": "shubham.raturi1@indegene.com",
        "name": "Shubham Raturi",
        "businessUnit": "Global Operations",
        "department": "Enterprise Technology",
        "reportingManagerName": "Anand Rao B S",
        "reportingManagerEmail": "ananda.rao@indegene.com",
        "employeeStatus": "ACTIVE",
        "accessStatus": "ACCESSIBLE"
    }
]

export const  formatNumberWithCommas=(number:any)=> {
  
  if(number===undefined || number===null){
    return number;
  }

  // Convert the number to a string
  const numStr = number.toString();
  
  // Split the integer and decimal parts
  const [integerPart, decimalPart] = numStr.split('.');
  
  // Add commas to the integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Combine the integer and decimal parts (if decimal part exists)
  const formattedNumber = decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  
  return formattedNumber;
}

export const isCRF_or_Amendment=(type:string)=>{
  if(type){
    if(type.includes('CRF') || type.includes('Amendment')){
      return true;
    }
  }

  return false;
}

export const isSOWEndDateUpdated=(sowEndDate:Date, originalSowEndDate:Date)=>{
  if(sowEndDate && originalSowEndDate){
    if(moment(sowEndDate).format('YYYY-MM-DD')!==moment(originalSowEndDate).format('YYYY-MM-DD')){
      return true;
    }
  }
  return false;
}

export const formatToTwoDecimalPlaces = (num: number): string => {
  
  return num?.toFixed(2) || '';
};